const STATIC_INTERESTS_DATA_BY_MONTH = {
  5: [
    {
      segment: "Развлечения, Отдых, Хобби",
      reach: "801 641",
      transitions: "26 945",
      affinityIndex: "76,7",
      conversions: "1 651",
    },
    {
      segment: "Продукты, еда и напитки ",
      reach: "521 741",
      transitions: "19 208",
      affinityIndex: "152,79",
      conversions: "1 544",
    },
    {
      segment: "Канцелярские принадлежности",
      reach: "124 005",
      transitions: "4 594",
      affinityIndex: "127,59",
      conversions: "1 594",
    },
    {
      segment: "Отдых, туризм, путешествия",
      reach: "106 993",
      transitions: "4 711",
      affinityIndex: "80,55",
      conversions: "1 559",
    },
    {
      segment: "Техника для сельского хозяйства ",
      reach: "194 219",
      transitions: "6 368",
      affinityIndex: "136,62",
      conversions: "1 548",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "93 214",
      transitions: "3 069",
      affinityIndex: "112,4",
      conversions: "845",
    },
    {
      segment: "Обустройство дома, ремонт",
      reach: "301 748",
      transitions: "9 410",
      affinityIndex: "125,92",
      conversions: "1 772",
    },
    {
      segment: "Бизнес, экономика, финансы",
      reach: "99 204",
      transitions: "3 978",
      affinityIndex: "90,75",
      conversions: "1 606",
    },
    {
      segment: "Техника и электроника",
      reach: "368 364",
      transitions: "11 390",
      affinityIndex: "144,69",
      conversions: "1 698",
    },
    {
      segment: "Связь, телефоны, интернет",
      reach: "259 874",
      transitions: "8 495",
      affinityIndex: "84,38",
      conversions: "907",
    },
  ],
  6: [
    {
      segment: "Продукты, еда и напитки",
      reach: "776 230",
      transitions: "15 695",
      affinityIndex: "142,88",
      conversions: "814",
    },
    {
      segment: "Техника для сельского хозяйства",
      reach: "362 108",
      transitions: "5 603",
      affinityIndex: "132,03",
      conversions: "607",
    },
    {
      segment: "Обустройство дома, ремонт",
      reach: "159 663",
      transitions: "7 630",
      affinityIndex: "127,75",
      conversions: "359",
    },
    {
      segment: "Техника и электроника",
      reach: "421 015",
      transitions: "12 104",
      affinityIndex: "123,54",
      conversions: "351",
    },
    {
      segment: "Профессиональный и любительский спорт",
      reach: "369 599",
      transitions: "8 416",
      affinityIndex: "113,35",
      conversions: "274",
    },
    {
      segment: "Собственность и недвижимость",
      reach: "158 747",
      transitions: "4 740",
      affinityIndex: "99,89",
      conversions: "468",
    },
    {
      segment: "Автомобили",
      reach: "599 621",
      transitions: "11 952",
      affinityIndex: "105,01",
      conversions: "511",
    },
    {
      segment: "Связь, телефоны, интернет",
      reach: "462 115",
      transitions: "9 653",
      affinityIndex: "88,69",
      conversions: "308",
    },
    {
      segment: "Канцелярские принадлежности",
      reach: "389 002",
      transitions: "7 466",
      affinityIndex: "96,3",
      conversions: "368",
    },
    {
      segment: "Товары для школьников",
      reach: "297 844",
      transitions: "2 652",
      affinityIndex: "96,3",
      conversions: "345",
    },
  ],
};

export default STATIC_INTERESTS_DATA_BY_MONTH;
